import React from "react";
import HandleStyleRadioGroup from "./HandleStyleRadioGroup";
import { cn } from "../../../../lib/utils";
import { internal_handles } from "../../../../lib/constant";

const InternalHandleStyle = ({ methods, isOpen: { InternalHandleStyle } }) => {
    return (
        <div
            className={cn(
                "section grid grid-cols-4 transition-all opacity-0 h-0 ",
                {
                    ["h-full opacity-100"]: InternalHandleStyle.isOpen,
                }
            )}
        >
            <HandleStyleRadioGroup
                path="internal"
                handles={internal_handles}
                {...methods}
            />
        </div>
    );
};

export default InternalHandleStyle;
